import "core-js/es6/map"; // <-- added this line after installed packages
import "core-js/es6/set"; // <-- added this line after installed packages
import "raf/polyfill"; // <-- added this line after installed packages

import React from "react";
import ReactDom from "react-dom";
import injectTapEventPlugin from "react-tap-event-plugin";
import "./index.css";
import Root from "./Root";
import "noty/lib/noty.css";
import registerServiceWorker from "./registerServiceWorker";

//injectTapEventPlugin();

ReactDom.render(<Root />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js